module.exports = __webpack_public_path__ + "src/assets/img/recommendation-1-2.476147f3.png";